import { FC } from 'react';
import { ActorVideo } from 'src/api/actors/types';
import { showMiddleVideoFrame } from 'src/utils/showMiddleVideoFrame';
import * as S from './styles';

export interface LocalVideoCardProps {
  video: ActorVideo;
  onPlay: (video: ActorVideo) => void;
  isSaved?: boolean;
  onToggleSaved?: (video: ActorVideo) => void;
}

export const LocalVideoCard: FC<LocalVideoCardProps> = ({
  video,
  onPlay,
  isSaved = false,
  onToggleSaved,
}) => (
  <S.Container>
    <S.Card type="button" onClick={() => onPlay(video)}>
      <S.Thumbnail
        src={video.url}
        muted
        playsInline
        preload="metadata"
        disablePictureInPicture
        onLoadedMetadata={showMiddleVideoFrame}
        aria-hidden
        data-testid="local-video-thumbnail"
      />
      <S.Caption>
        <S.Learnable>{video.learnable}</S.Learnable>
        <S.Translation>{video.translation}</S.Translation>
      </S.Caption>
    </S.Card>
    {onToggleSaved && (
      <S.SaveButton
        word={video.learnable}
        isSaved={isSaved}
        onToggle={() => onToggleSaved(video)}
        variant="overlay"
      />
    )}
  </S.Container>
);
